var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMagicLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11413 4.85935C3.35999 5.10762 3.64368 5.23175 3.96519 5.23175C4.2867 5.23175 4.57039 5.10762 4.81625 4.85935C5.06212 4.61109 5.18505 4.32463 5.18505 3.99998C5.18505 3.67533 5.06212 3.38887 4.81625 3.1406C4.57039 2.89234 4.2867 2.76821 3.96519 2.76821C3.64368 2.76821 3.35999 2.89234 3.11413 3.1406C2.88718 3.38887 2.7737 3.67533 2.7737 3.99998C2.7737 4.32463 2.88718 4.61109 3.11413 4.85935ZM7.39781 2.76821H13.6673V5.23175H12.4475V7.66665H10.0361V5.23175H7.39781C7.15195 5.90015 6.68859 6.47307 6.00774 6.9505C5.3458 7.42793 4.66495 7.66665 3.96519 7.66665C2.96283 7.66665 2.10231 7.31335 1.38363 6.60675C0.683866 5.88106 0.333984 5.01213 0.333984 3.99998C0.333984 2.98783 0.683866 2.12845 1.38363 1.42185C2.10231 0.69616 2.96283 0.333313 3.96519 0.333313C4.66495 0.333313 5.3458 0.572028 6.00774 1.04946C6.68859 1.52689 7.15195 2.09981 7.39781 2.76821Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicLink);
export default __webpack_public_path__ + "static/media/icon-magic-link.6ffe692a3408999163749f8fbd22f2d4.svg";
export { ForwardRef as ReactComponent };